// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"267":"92aacb17","472":"6686779e","577":"534fa344","624":"807b16cb","660":"aaef56e4","688":"e90384ae","838":"1deb06e9","890":"c9a2d310","928":"73d4784c"}[chunkId] + ".chunk.css";
};